import { render, staticRenderFns } from "./SettingWechat.vue?vue&type=template&id=675748fc&scoped=true"
import script from "./SettingWechat.vue?vue&type=script&lang=js"
export * from "./SettingWechat.vue?vue&type=script&lang=js"
import style0 from "./SettingWechat.vue?vue&type=style&index=0&id=675748fc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675748fc",
  null
  
)

export default component.exports